import { render, staticRenderFns } from "./TemplateDetailsPreview.vue?vue&type=template&id=ea1bd5be&"
import script from "./TemplateDetailsPreview.vue?vue&type=script&lang=js&"
export * from "./TemplateDetailsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports